import React from "react";

import i18n from 'i18next';
import {
  Callout,
  Button,
  Collapse,
  Tag,
  HTMLTable
} from "@blueprintjs/core";
import { Trans } from "react-i18next";

class Errors extends React.Component {
  state = {
    isOpen: false,
  };

  render() {
    if (this.props.list !== undefined && Array.isArray(this.props.list) && this.props.list.length > 0) {
      return (
        <Callout intent="danger">
          <Button onClick={() => { this.setState({ isOpen: !this.state.isOpen }); }}>
            {this.state.isOpen ? i18n.t("hide") : i18n.t("show")} <Tag intent="danger">{this.props.list.length}</Tag> {i18n.t("active error(s)")}
          </Button>
          <Collapse isOpen={this.state.isOpen}>
            <HTMLTable bordered={true} striped={true} compact={true}>
              <tbody>
                {this.props.list}
              </tbody>
            </HTMLTable>
          </Collapse>
        </Callout>
      );
    }
    else
      return (<br />);
  }
}

class Warnings extends React.Component {
  state = {
    isOpen: false,
  };

  render() {
    if (this.props.list !== undefined && Array.isArray(this.props.list) && this.props.list.length > 0) {
      return (
        <Callout intent="warning">
          <Button onClick={() => { this.setState({ isOpen: !this.state.isOpen }); }}>
            {this.state.isOpen ? i18n.t("hide") : i18n.t("show")} <Tag intent="warning">{this.props.list.length}</Tag> {i18n.t("active failure(s)")}
          </Button>
          <Collapse isOpen={this.state.isOpen}>
            <HTMLTable bordered={true} striped={true} compact={true}>
              <tbody>
                {this.props.list}
              </tbody>
            </HTMLTable>
          </Collapse>
        </Callout>
      );
    }
    else
      return (<br />);
  }
}

export default function Summary(props) {
  if(props.errors.length || props.warnings.length)
    return (
      <div className="flexbox-center">
        <Callout title={<Trans>summary</Trans>}>
          <div className="flexbox-center">
            <div style={{ width: "45%" }}><Errors list={props.errors} isOpen={props.isOpen} /></div>
            <div style={{ width: "45%" }}><Warnings list={props.warnings} /></div>
          </div>
        </Callout>
      </div>
    );
  else return null;
}